import {
	type RecordLearningConceptExplainedMutation,
	type RecordLearningWalkthroughOutcomeMutation
} from "~/gql/mutations/learning.generated";
import { type MyLearningPathQuery, type MyWalkthroughStateQuery } from "~/gql/queries/learning.generated";

const learningEndpoints = {
	MyLearningPath: {
		providesTags: ["Learning"] as AddTagTypes,
		transformResponse: (res: MyLearningPathQuery) => res
	},
	MyWalkthroughState: {
		providesTags: ["Learning"] as AddTagTypes,
		transformResponse: (res: MyWalkthroughStateQuery) => res
	},
	RecordLearningConceptExplained: {
		invalidatesTags: ["Learning"] as AddTagTypes,
		transformResponse: (res: RecordLearningConceptExplainedMutation) => res
	},
	RecordLearningWalkthroughOutcome: {
		invalidatesTags: ["Learning"] as AddTagTypes,
		transformResponse: (res: RecordLearningWalkthroughOutcomeMutation) => res
	}
};

export default learningEndpoints;
